import { FC } from 'react'
import { StyledBox } from './PlanTableMonthHeader.styles.ts'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import {
  shouldHighlightMonth,
  isCurrentMonth,
} from '@/core/utils/shouldHighlightMonth.ts'

interface Props {
  date: Date
}

const PlanTableMonthHeader: FC<Props> = ({ date }) => {
  const shouldHighlight = shouldHighlightMonth(date)
  const isCurrent = isCurrentMonth(date)

  const { t } = useTranslation()

  return (
    <StyledBox
      highlight={shouldHighlight}
      sx={{ fontWeight: isCurrent ? 700 : 400 }}
    >
      {dayjs(date).format(t('planTableMonthHeader.dateFormat'))}
    </StyledBox>
  )
}

export default PlanTableMonthHeader
